var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.911,
    height: 40,
    viewBox: "0 0 35.911 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target",
    transform: "translate(-37.511 -11.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132500",
    "data-name": "Group 132500",
    transform: "translate(37.511 11.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132498",
    "data-name": "Group 132498",
    transform: "translate(0 9.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1173",
    "data-name": "Ellipse 1173",
    d: "M.234-7.5A7.7,7.7,0,0,1,7.969.157,7.7,7.7,0,0,1,.234,7.813,7.7,7.7,0,0,1-7.5.157,7.7,7.7,0,0,1,.234-7.5Zm0,14.111A6.5,6.5,0,0,0,6.767.157,6.5,6.5,0,0,0,.234-6.3,6.5,6.5,0,0,0-6.3.157,6.5,6.5,0,0,0,.234,6.611Z",
    transform: "translate(17.721 7.988)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1173_-_Outline",
    "data-name": "Ellipse 1173 - Outline",
    d: "M.222-7.512A7.7,7.7,0,0,0-7.512.144,7.7,7.7,0,0,0,.222,7.8,7.7,7.7,0,0,0,7.957.144,7.7,7.7,0,0,0,.222-7.512M.222,6.6A6.5,6.5,0,0,1-6.31.144,6.5,6.5,0,0,1,.222-6.31,6.5,6.5,0,0,1,6.755.144,6.5,6.5,0,0,1,.222,6.6M.222-8A8.193,8.193,0,0,1,8.444.144,8.193,8.193,0,0,1,.222,8.289,8.193,8.193,0,0,1-8,.144,8.193,8.193,0,0,1,.222-8Zm0,14.111A6.013,6.013,0,0,0,6.267.144,6.013,6.013,0,0,0,.222-5.822,6.013,6.013,0,0,0-5.822.144,6.013,6.013,0,0,0,.222,6.111Z",
    transform: "translate(17.733 8)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_132497",
    "data-name": "Group 132497",
    transform: "translate(0 20.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95936",
    "data-name": "Path 95936",
    d: "M136.79,393.716H115.355a.6.6,0,0,1-.548-.847l3.594-8.013a.6.6,0,0,1,1.1.492l-3.214,7.166h19.578l-3.214-7.166a.6.6,0,0,1,1.1-.492l3.594,8.013a.6.6,0,0,1-.548.847Z",
    transform: "translate(-108.117 -384.013)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95936_-_Outline",
    "data-name": "Path 95936 - Outline",
    d: "M136.777,393.7a.6.6,0,0,0,.548-.847l-3.594-8.013a.6.6,0,0,0-1.1.492l3.214,7.166H116.271l3.214-7.166a.6.6,0,0,0-1.1-.492l-3.594,8.013a.6.6,0,0,0,.548.847h21.435m0,.488H115.343a1.089,1.089,0,0,1-.993-1.534l3.594-8.013a1.089,1.089,0,1,1,1.987.891l-2.905,6.479H135.1l-2.905-6.479a1.089,1.089,0,1,1,1.987-.891l3.593,8.013a1.089,1.089,0,0,1-.993,1.534Z",
    transform: "translate(-108.104 -384.001)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_360",
    "data-name": "Line 360",
    d: "M26.835-6.3H-6.9a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6H26.835a.6.6,0,0,1,.6.6A.6.6,0,0,1,26.835-6.3Z",
    transform: "translate(7.988 16.001)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_360_-_Outline",
    "data-name": "Line 360 - Outline",
    d: "M26.823-6.31a.6.6,0,0,0,.6-.6.6.6,0,0,0-.6-.6H-6.911a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6H26.823m0,.488H-6.911A1.09,1.09,0,0,1-8-6.911,1.09,1.09,0,0,1-6.911-8H26.823a1.09,1.09,0,0,1,1.089,1.089A1.09,1.09,0,0,1,26.823-5.822Z",
    transform: "translate(8 16.013)",
    fill: "#09143a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132499",
    "data-name": "Group 132499",
    transform: "translate(16.867 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_361",
    "data-name": "Line 361",
    d: "M-6.9,6.286a.6.6,0,0,1-.427-.178.6.6,0,0,1,0-.85L5.4-7.326a.6.6,0,0,1,.85,0,.6.6,0,0,1,0,.85L-6.476,6.112A.6.6,0,0,1-6.9,6.286Z",
    transform: "translate(7.988 11.792)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_361_-_Outline",
    "data-name": "Line 361 - Outline",
    d: "M-6.911,6.274A.6.6,0,0,0-6.489,6.1L6.234-6.484a.6.6,0,0,0,0-.85.6.6,0,0,0-.85,0L-7.334,5.245a.6.6,0,0,0,0,.85.6.6,0,0,0,.427.178m0,.488a1.081,1.081,0,0,1-.774-.323A1.082,1.082,0,0,1-8,5.667,1.082,1.082,0,0,1-7.677,4.9L5.046-7.685A1.082,1.082,0,0,1,5.811-8a1.081,1.081,0,0,1,.774.323,1.082,1.082,0,0,1,.315.772,1.082,1.082,0,0,1-.323.768L-6.146,6.447A1.082,1.082,0,0,1-6.911,6.761Z",
    transform: "translate(8 11.804)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95937",
    "data-name": "Path 95937",
    d: "M408.689,17.44a.6.6,0,0,1-.584-.741l.9-3.74a.6.6,0,1,1,1.169.281l-.67,2.791,2.831-.665a.6.6,0,0,1,.275,1.17l-3.781.889A.6.6,0,0,1,408.689,17.44Z",
    transform: "translate(-394.812 -12.01)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95937_-_Outline",
    "data-name": "Path 95937 - Outline",
    d: "M408.677,17.428a.6.6,0,0,0,.137-.016l3.781-.889a.6.6,0,0,0-.275-1.17l-2.831.665.67-2.791a.6.6,0,1,0-1.169-.281l-.9,3.74a.6.6,0,0,0,.584.741m0,.488a1.089,1.089,0,0,1-1.059-1.343l.9-3.74a1.089,1.089,0,0,1,2.117.509l-.486,2.021,2.06-.484a1.089,1.089,0,1,1,.5,2.12l-3.781.889A1.09,1.09,0,0,1,408.677,17.916Z",
    transform: "translate(-394.8 -11.998)",
    fill: "#09143a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_95938",
    "data-name": "Path 95938",
    d: "M76.462,63.187A15.477,15.477,0,1,1,92.1,47.711,15.2,15.2,0,0,1,90.795,53.9a.6.6,0,0,1-1.1-.487c.052-.117.1-.235.265-.639a13.6,13.6,0,0,0,.939-5.067,14.39,14.39,0,1,0-6.124,11.664.6.6,0,0,1,.689.985A15.637,15.637,0,0,1,76.462,63.187Z",
    transform: "translate(-20.995 -18.167)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95938_-_Outline",
    "data-name": "Path 95938 - Outline",
    d: "M76.45,63.175a15.637,15.637,0,0,0,9-2.827.6.6,0,1,0-.689-.985A14.239,14.239,0,1,1,90.888,47.7a13.6,13.6,0,0,1-.939,5.067c-.162.4-.213.522-.265.639a.6.6,0,0,0,1.1.487A15.2,15.2,0,0,0,92.09,47.7,15.641,15.641,0,1,0,76.45,63.175m0,.488A15.965,15.965,0,1,1,92.578,47.7a15.68,15.68,0,0,1-1.349,6.39,1.089,1.089,0,1,1-1.991-.882c.047-.106.093-.213.258-.623a13.083,13.083,0,0,0,.9-4.885,13.9,13.9,0,1,0-5.916,11.264,1.089,1.089,0,0,1,1.247,1.785A16.123,16.123,0,0,1,76.45,63.662Z",
    transform: "translate(-20.983 -18.155)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpose);
export default __webpack_public_path__ + "static/media/purpose.117108580bf5046ef4e8e8bf79eede62.svg";
export { ForwardRef as ReactComponent };